import { render, staticRenderFns } from "./MJoin.vue?vue&type=template&id=e05f2944&"
import script from "./MJoin.vue?vue&type=script&lang=js&"
export * from "./MJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports